export default __webpack_public_path__ + "src/assets/close.52041ae091ed56e0ee943e1aa18e8870.svg";